import { MijnRoute } from '../mijn-navigatie.model';

export const DOCUMENT_OVERVIEW: MijnRoute = {
    path: 'documenten',
    navigationEvent: 'toDocumenten',
    regex: /^\/documenten$/,
    webcomponent: 'mijn-documenten-overzicht-webcomponent'
};
